import React from 'react'

import { TheWestMark } from '../../../../logos/TheWestMark/TheWestMark'

import { VideoDetails } from '@news-mono/web-common'
import {
    StyledTopBar,
    StyledInset,
    StyledHeading,
    StyledVideoMetadata,
    StyledHeadingAndLogoContainer,
} from '../../../../content/Video/components/TopBar/TopBar.styled'
import { StyledSourceFallback } from '../../../../publication/SourceLogo/SourceLogo.styled'
import { ThemedRender } from '../../../../__styling/themed-render'
import { Theme } from '@emotion/react'

export interface TopBarProps {
    isVisible: boolean
    videoDetails: VideoDetails
    videoDuration?: string
    theme: Theme
    compactMode?: boolean
}

const StackedTopBar: React.FC<TopBarProps> = (props) => (
    <StyledTopBar
        className="video-js__overlay video-js__overlay--pause"
        isVisible={props.isVisible}
    >
        <StyledInset className="video-js__metadata">
            <StyledHeading className="video-js__heading">
                {props.videoDetails.heading}
            </StyledHeading>
            {props.theme.kind === 'thewest' && (
                <TheWestMark className="video-js__logo" />
            )}
            <StyledVideoMetadata
                duration={
                    props.theme.kind === 'thewest'
                        ? props.videoDuration
                        : undefined
                }
                source={props.videoDetails.source}
                type={props.videoDetails.videoType}
            />
        </StyledInset>
    </StyledTopBar>
)

const LandscapeTopBar: React.FC<TopBarProps> = ({
    isVisible,
    videoDetails,
    compactMode,
}) => {
    const { source } = videoDetails
    return (
        <StyledTopBar
            compactMode={compactMode}
            className="video-js__overlay video-js__overlay--pause"
            isVisible={isVisible}
        >
            <StyledInset className="video-js__metadata">
                <StyledHeadingAndLogoContainer>
                    <StyledHeading className="video-js__heading">
                        {videoDetails.heading}
                    </StyledHeading>
                </StyledHeadingAndLogoContainer>
                {source && (
                    <StyledSourceFallback>
                        (Source: {source})
                    </StyledSourceFallback>
                )}
            </StyledInset>
        </StyledTopBar>
    )
}

export const TopBar: React.FC<TopBarProps> = (props) => {
    return (
        <ThemedRender
            sevennews={() => <LandscapeTopBar {...props} />}
            thewest={() => <StackedTopBar {...props} />}
            perthnow={() => <StackedTopBar {...props} />}
        />
    )
}
TopBar.displayName = 'TopBar'
